// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__nHe0D","calendarButtons":"ClockData_calendarButtons__3pZBy"};